// extracted by mini-css-extract-plugin
module.exports = {"lobby":"lobby_lobby__SmdQC"};